import React, { useState, useEffect, useRef } from 'react';
import { TextField } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

const EditableCell = ({
  value,
  onChange,
  disabled = false,
  align = 'center',
}) => {
  const theme = useTheme();
  const inputRef = useRef(null);

  const [localValue, setLocalValue] = useState(value ?? '');
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) setLocalValue(value ?? '');
  }, [value, isEditing]);

  const commitIfChanged = (nextValue) => {
    const next = nextValue ?? '';
    const prev = value ?? '';
    if (onChange && next !== prev) onChange(next);
  };

  const handleFocus = () => {
    if (disabled || isEditing) return;
    setIsEditing(true);
    // optional: select all the text inside the cell
    requestAnimationFrame(() => inputRef.current?.select?.());
  };

  const handleBlur = () => {
    setIsEditing(false);
    commitIfChanged(localValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      inputRef.current?.blur();
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      setLocalValue(value ?? '');
      setIsEditing(false);
      setTimeout(() => inputRef.current?.blur(), 0);
    }
  };

  return (
    <TextField
      fullWidth
      value={localValue}
      disabled={disabled}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      onChange={(e) => setLocalValue(e.target.value)}
      InputProps={{
        disableUnderline: true,
        readOnly: !isEditing || disabled,
        inputRef,
        style: {
          color: isEditing && !disabled ? '#000' : theme.palette.grey[500],
        },
      }}
      inputProps={{
        style: {
          textAlign: align,
          cursor: isEditing && !disabled ? 'text' : 'default',
        },
      }}
      style={{
        width: '100%',
        padding: 10,
      }}
    />
  );
};

export default EditableCell;
